import { createSvgIcon } from "@mui/material";

export const CompanyIcon = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path d="M1.5 14H14.5M2.5 2V14M9.5 2V14M13.5 5V14M4.5 4.5H5M4.5 6.5H5M4.5 8.5H5M7 4.5H7.5M7 6.5H7.5M7 8.5H7.5M4.5 14V11.75C4.5 11.336 4.836 11 5.25 11H6.75C7.164 11 7.5 11.336 7.5 11.75V14M2 2H10M9.5 5H14M11.5 7.5H11.5053V7.50533H11.5V7.5Z" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>,
    'CompanyIcon'
)
